import { API_BASE_URL } from "@/config";
import { showSnackbar } from "@/app/shared/utils/snackbar";

export async function interceptor(url: string, options: any = {}) {
  const fullUrl = url.startsWith("http")
    ? url
    : `${API_BASE_URL}${url}`;

  const headers = new Headers(options.headers || {});
  headers.set("Content-Type", "application/json");

  const response = await fetch(fullUrl, {
    ...options,
    headers,
    credentials: "include",
  });

  if (!response.ok) {
    if (response.status === 401) {
      console.error("Unauthorized - 401");
    }

    let errorMessage = `HTTP Error ${response.status}`;
    try {
      const err = await response.json();
      errorMessage = err?.message || errorMessage;
    } catch {}

    const error = new Error(errorMessage) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }

  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return response.json();
  }

  return response.text();
}


